import React from 'react'
import '../Style/InfoPage.css'
import '../Style/experience.css';
import SkillBlock from '../SkillBlock';
import { useState, useEffect, useRef } from "react";
import close from "../Graphics/x.png"

import terminalMon from "../Graphics/terminalmonopoly.gif"
import ops from "../Graphics/ops.png"
import placeholder from "../Graphics/placeholderwide.png"
import gisLab from "../Graphics/GISLabImage.png"
import psi from "../Graphics/PSIExperienceImage.png"
import gympic from "../Graphics/gym lift.jpg"


const InfoPage = ({setVis, visible}) => {
  

    const [borderWidth,setBorderWidth] = useState(0);
     const [borderHeight,setBorderHeight] = useState(0);
     const insideRef = useRef(null);
 
    const offset=16;
   function pixelSpacing(){
   if(!insideRef.current) return;
   const insideDiv=insideRef.current.getBoundingClientRect();
   
   setBorderHeight(insideDiv.height+offset);
   setBorderWidth(insideDiv.width+offset);
  
 }

   useEffect(() => {
     // Call the function initially to set the values
     pixelSpacing();
 
     // Add event listener for window resize
     window.addEventListener('resize', pixelSpacing);
 
     // Cleanup the event listener on component unmount
     return () => {
       window.removeEventListener('resize', pixelSpacing);
     };
   }, [visible]);

  return (
    <div className={visible ? "main" : "main panelHidden"}>
      <div className="verticalOutline" style={{height:`${borderHeight}px`,top:`${-(offset/2)}px`}}></div>
      <div className="horizontalOutline" style={{width:`${borderWidth}px`,left:`${-(offset/2)}px`}}></div>
      <img src={close} alt="Close" className="closeButton" onClick={() => setVis(-1)}/>
      <div className="inside" ref={insideRef} style={{borderWidth:`${(offset/2)}px`}}>
      <h2 style={{textAlign:'center'}}>Experience</h2>
            {/* <h3 style={{textAlign:'center'}}>Technical Skills</h3>
        <div className="skillsFlex">
          <div className="skillItem">
              <p><b><u>Front-End</u></b></p>
              <p className="skillBlock">React</p>
              <p className="skillBlock">Svelte</p>
              <p className="skillBlock">JavaScript</p>
              <p className="skillBlock">Typescript</p>
          </div>
          <div className="skillItem">
              <p><b><u>Back-End</u></b></p>
          </div>
          <div className="skillItem">
              <p><b><u>Programming</u></b></p>
              <p className="skillBlock">Java</p>
              <p className="skillBlock">C++</p>
              <p className="skillBlock">React</p>
              <p className="skillBlock">Python</p>
               <p className="skillBlock">Koitlin</p>
          </div>
          <div className="skillItem">
              <p><b><u>Misc</u></b></p>
              <p className="skillBlock">Github</p>
              <p className="skillBlock">Blockbench</p>
              <p className="skillBlock">Texture Art</p>
          </div>

        </div> */}
            {/* <h3 style={{textAlign:'center'}}>Extra Curriculars</h3> */}
            <div className='clubSpacing'>

              <h3  style={{margin:"0"}}><u>UF Geospatial Digital Informatics Lab &#40;Sept. 2025 - Present&#41;</u></h3>
              <div style={{display:"flex",flexWrap:"wrap",}}>
                 <p className='clubText'>
                  Currently working as a Research Assistant at the UF Geospatial Digital Informatics Lab under Professor Di Yang. Some of the work I'm currently or have done is:
                  <ul>
                    <li>Designed a workflow to automatically georeference points between super old satellite imagery and NAIP imagery using ML models</li>
                    <li>Trained a model using the U-Net Computer Vision architecture to identify land-use categories in historical satellite imagery</li>
                  </ul>
                  </p>

              <img className='clubImages' loading="lazy"
              src={gisLab} alt="Satellite imagery work at the GIS Lab"></img>
              </div>


              <h3  style={{margin:"0",marginTop:"2%"}}><u>Patriot Surveying and Infrastructure &#40;May 2026 - July 2026&#41;</u></h3>
              <div style={{display:"flex",flexWrap:"wrap",}}>
                 <p className='clubText'>
                  Worked as a Full Stack Development Intern over the summer of 2026, created the PSI Webmap to serve public and private lidar
                  and shapefile data to reduce the time of the geospatial team getting the data for them. Also automated canopy tree line outlining, and introduced them to Microsoft Planner!
                  </p>

              <img className='clubImages' loading="lazy"
              src={psi} alt="The PSI Webmap"></img>
              </div>


              <h3  style={{margin:"0",marginTop:"2%"}}><u>Open Source Club, Project Team Lead &#40;Aug. 2025 - May 2026&#41;</u></h3>
              <div style={{display:"flex",flexWrap:"wrap",}}>
                 <p className='clubText'>Led and mentored a team of 13 to create the OSC Workout App, a
                  progressive web app made to be a completely free and offline workout tracker.
                  <br></br>&nbsp;&nbsp;&nbsp;&nbsp;Hosted React and Git &amp; Github workshops covering state
                  management, OOP, CI/CD, and Linux shell scripting, and ran the project on Agile sprints with
                  weekly scrums and Github Issues to track progress
                  <br></br>Written in HTML/CSS/Javascript with React
                  </p>

              <img className='clubImages' loading="lazy"
              src={gympic} alt="Guy lifting weights"></img>
              </div>


              <h3  style={{margin:"0",marginTop:"2%"}}><u>Open Source Club &#40;Fall 2024 - Spring 2025&#41;</u></h3>
              <div style={{display:"flex",flexWrap:"wrap",}}>
                 <p className='clubText'>Worked on Terminal Monopoly, 
                  an online version of monopoly created with ASCII art. Created a mini-game called Space Trucker, a 
                  parody of asteroid where you have to survive increasingly difficult random events 
                  <br></br>Written in Python
                  </p>
                 
                  
              <img className='clubImages' loading="lazy"
              src={terminalMon} alt="Terminal Monopoly, Writing in ASCII art"></img>
              </div>


              <h3  style={{margin:"0",marginTop:"2%"}}><u>Open Project Space &#40;Fall 2024 - Spring 2025&#41;</u></h3>
              <div style={{display:"flex",flexWrap:"wrap",}}>
                 <p className='clubText'> A weekly club offered by IEEE to learn electrical engineering
                  concepts without taking the elcetrical engineering classes proper. Learned how to utilize
                  and program micro-controllers alongside various circuits
                  <br></br>&nbsp;&nbsp;&nbsp;&nbsp;Created weekly hardware  projects for the class, with a final
                  project of me and my partner recreating doodle jump!
                  </p>
                 
                  
              <img className='clubImages' loading="lazy"
              src={ops} alt="Open Project Space logo"></img>
              </div>
             
            </div>

        
        
      </div>
    </div>
  )
}

export default InfoPage